import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconShield,
  IconEye,
  IconRobot,
  IconChecklist,
} from '@tabler/icons-react';

const devSecOpsFeatures: FeatureData[] = [
  {
    title: 'Direction & DSI',
    description:
      "Gouvernez la sécurité et réduisez les risques cyber avec une approche DevSecOps structurée.",
    icon: <IconShield size={24} />,
    key: 'devSecOps.features.digitalTransformation'
  },
  {
    title: 'Développeurs & DevOps',
    description:
      'Intégrez la sécurité nativement sans ralentir vos cycles de développement.',
    icon: <IconRobot size={24} />,
    key: 'devSecOps.features.startups'
  },
  {
    title: 'RSSI & Sécurité',
    description:
      'Automatisez les contrôles de sécurité et maintenez la conformité en continu.',
    icon: <IconEye size={24} />,
    key: 'devSecOps.features.industrial'
  },
  {
    title: 'Compliance & Audit',
    description:
      'Assurez la traçabilité complète et la conformité réglementaire automatisée.',
    icon: <IconChecklist size={24} />,
    key: 'devSecOps.features.publicSector'
  },
];

export default devSecOpsFeatures;